import { useEffect, useState } from 'react';
import { A01 } from 'api/U009';
import { A01Output } from 'api/U009';

export interface RecrutingAuditions {
  limit: number;
  auditions: Array<RecrutingAudition>;
  now_dtm: Date;
}

export interface RecrutingAudition {
  id: string;
  lang: string;
  lpUrl: string;
  image: string;
  title: string;
  detail: string;
  end: Date;
  year_round: string;
}

export function useGetRecruitingAuditions(
  lang: string
): [RecrutingAuditions | undefined, boolean, Error | null] {
  const [loading, setLoading] = useState<boolean>(true);
  const [audition, setAudition] = useState<RecrutingAuditions>();
  const [err, setError] = useState<Error | null>(null);

  const fetchRecrutingAuditions = async (lang: string, cancellation: AbortSignal) => {
    const json = (await A01(lang, cancellation)) as A01Output;
    return {
      limit: json.limit,
      now_dtm: new Date(json.now_dtm),
      auditions: json.auditions.map((obj) => {
        return {
          id: obj.id,
          lang: obj.lang,
          lpUrl: obj.lp_url,
          image: obj.image,
          title: obj.title,
          detail: obj.detail,
          end: new Date(obj.end_dtm),
          year_round: obj.year_round,
        };
      }),
    } satisfies RecrutingAuditions;
  };

  useEffect(() => {
    const controller = new AbortController();
    const cancellation = controller.signal;
    async function fetch() {
      try {
        setLoading(true);
        setError(null);
        const auditions = await fetchRecrutingAuditions(lang, cancellation);
        setAudition(auditions);
        setLoading(false);
      } catch (err) {
        if (err instanceof DOMException && err.message === 'signal is aborted without reason')
          return;
        console.error(err);
        setError(err instanceof Error ? err : new Error(`unknown error. ${err}`));
        setLoading(false);
      }
    }

    fetch();
    return () => {
      controller.abort();
    };
  }, [lang]);

  return [audition, loading, err];
}
